<template>
  <div
    v-if="shouldDisplayEmptyState"
    class="pa-0 white"
    data-testid="explore-searchBarResults"
  >
    <v-icon color="blue-grey lighten-1" class="font-size-24 w-100 pt-9">
      mdi-ghost-outline
    </v-icon>
    <div
      class="w-100 text-center no-results-title subtitle-2 blue-grey--text text--darken-1"
    >
      {{ $t('common.no_results_found') }}
    </div>
    <div class="w-100 text-center body-2 blue-grey--text no-results-subtitle">
      {{ $t('explore.empty_search_results_message') }} {{ searchValue }}
    </div>
  </div>
  <v-list nav dense v-else>
    <template v-if="results.length">
      <SearchBarResultItem
        v-for="item in results"
        :key="item.response.id"
        :item="item"
        :searchValue="searchValue"
        @openTask="$emit('openTask', $event)"
        @openFinding="$emit('openFinding', $event)"
        @selectResult="$emit('selectResult', $event)"
      />

      <div
        class="more-results cursor-pointer body2 blue--text px-6 py-3"
        @click="$emit('viewMore')"
      >
        {{ $t('common.more_results') }}
      </div>
    </template>
  </v-list>
</template>

<script>
import SearchBarResultItem from './SearchBarResultItem.vue'

export default {
  name: 'SearchBarResults',

  components: {
    SearchBarResultItem,
  },

  props: {
    loading: Boolean,
    isContentRequested: Boolean,
    results: Array,
    searchValue: String,
  },

  computed: {
    shouldDisplayEmptyState() {
      return this.isContentRequested && this.results?.length == 0
    },
  },
}
</script>

<style scoped>
.more-results {
  min-height: 40px;
}
.no-results-title {
  padding-top: 14.5px;
}
.no-results-subtitle {
  padding: 8px 124px 32px 124px;
}
</style>
